import React from 'react';

import { VpHookFormInput } from '../../inputs';

export const VpMediaTitleInput = ({ ...rest }) => {
  return <VpHookFormInput label="Title" fullWidth maxLength={500} name="title" {...rest} />;
};

export default VpMediaTitleInput;



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/media-details/VpMediaTitleInput.jsx